import { useQuery } from '@tanstack/react-query'

import { SupportedChainId } from '~/constants/chains'
import { QUERY_KEYS } from '~/constants/react-query'
import { useServerRequests } from '~/hooks/useRequests'
import { IAddress } from '~/types'
import { Address } from '~/utils/address'

export const PRICE_CHART_PERIODS = ['24h', '7d', '30d', '1y'] as const
export type PriceChartPeriod = (typeof PRICE_CHART_PERIODS)[number]

export type PricePoint = { t: number; p: number }

type PriceChartResponse = {
  coinId: string | null
  period: PriceChartPeriod
  prices: PricePoint[]
}

// 5 minutes
const STALE_TIME_MS = 300_000

export const useTokenPriceChart = ({
  chainId,
  address,
  period,
}: {
  chainId: SupportedChainId
  address: IAddress
  period: PriceChartPeriod
}) => {
  const { serverGetRequest } = useServerRequests()
  const normalized = Address.format(address)

  return useQuery({
    queryKey: [QUERY_KEYS.TOKEN_PRICE_CHART, chainId, normalized, period],
    queryFn: async () => {
      const result = await serverGetRequest<PriceChartResponse>({
        path: `/api/tokens/${chainId}/${normalized}/price-chart?period=${period}`,
      })
      if (!result) throw new Error('Failed to fetch token price chart')
      return result.data
    },
    staleTime: STALE_TIME_MS,
  })
}
